import React,{ useContext, useEffect, useState } from "react";
import { AxiosInstance, DialogType, FormActions, FormatPrice } from "../utils/constants";
import { AutoCompleteInputWithLabel, InputWithLabel, SelectInputWithLabel } from "../components/form/custom-imputs";
import  * as yup from "yup";
import { ActionTypes, AppContext } from "../store/AppStore";
import { Card, CardContent, GridLegacy as Grid, IconButton, Typography } from '@mui/material';
import { Delete } from "@mui/icons-material";



const usuariosAsociados  = yup.object({
  usuario:yup.string().required(),
  cod_tipo_identificacion:yup.string().required(),
  nro_identificacion:yup.string().required(),
  celular:yup.string().required(),
  email:yup.string().optional().nullable().notRequired(),
  
});

const validateDatosClientes  = yup.object({
    cliente:yup.object().required(),
    clasificacion_cliente:yup.string().required(),
    razon_social:yup.string().required(),
    nit:yup.string().required(),
    tipo_documento:yup.string().required(),
    email_notificaciones:yup.string().nullable().optional().notRequired(),
    celular_notificaciones:yup.string().length(10).required(),
    usuarios_plataforma:yup.array(usuariosAsociados).min(1),
    direccion_entrega:yup.string().required(),
    municipio:yup.mixed().required(),
    barrio:yup.mixed().required(),
});




const UsuariosList  = ({
   onDeleteIcon,
   cod,
   usuario,
   maestros,
   nro_identificacion,
   cod_tipo_identificacion,
   celular,
   email
})=>{
  

  const identificacion = maestros?.tipos_identificacion?.find(item=>item.value == cod_tipo_identificacion );

  return (<Card sx={{width:'100%',marginBottom:'5px'}} >
      
    <CardContent>
      
      <Grid container >
        <Grid item sx={12} md={12} >
          <Typography variant="p" ><strong>NOMBRE: {usuario}</strong></Typography> 
        </Grid>
        <Grid container item sx={10} md={10} >
      
           <Grid item sx={12} md={12} sm={12} >
              <Typography><strong>DOCUMENTO:</strong> {identificacion?.label} N°:{nro_identificacion}</Typography>
            </Grid>
          
            <Grid item sx={6} md={6} sm={6} >
              <Typography><strong>CELULAR:</strong>{ celular}</Typography>
            </Grid>
            <Grid item sx={12} md={12} sm={12} >
              <Typography><strong>Correo:</strong>{ email || 'N/A'}</Typography>
            </Grid>
          
           
        </Grid>
        <Grid item sx={2} md={2} >
            <IconButton disabled={!!cod}  onClick={onDeleteIcon} sx={{background:"red",color:"white"}}   >
              <Delete  />
            </IconButton>
        </Grid>
      </Grid>
        
    </CardContent>
  </Card>)

}

export const useClientActivacion = ({callbackOnCreate=()=>{},maestrosCompartidos})=>{


    const {dispatch,store:{profile}} = useContext( AppContext );
    const [clienteFiltro,setClienteFiltro] = useState([]);
    const configuracionApp = profile.configuracion_comp? JSON.parse(profile.configuracion_comp):{};
    const [ciudades,setCiudades] = useState([]);
    const [barrios,setBarrios] = useState([]);
    useEffect(()=>{
    
    },[]);



   const onSendFormClient = (formData,formConnect)=>{
    let newFormData = {...formData,creado_por_admin:'SI',cod_municipio:formData.municipio.value,cod_barrio:formData.barrio.value};
    newFormData.cliente = newFormData.cliente.value;

    dispatch({
      type:ActionTypes.setLoadingPage,
      data:true
    });

    AxiosInstance.post("maestros-marketplace/activacion-clientes",newFormData).then( ({data})=>{
      callbackOnCreate();
      if (data.status){
        formConnect.reset(defaultDataForm);
     
/*         formConnect.setValue("razon_social","");
        formConnect.setValue("nit",""); */
/*         Object.keys(defaultDataForm).forEach(keyItem=>{
          formConnect.setValue(keyItem,defaultDataForm[keyItem]);
        }); */
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Activacion exitosa",
              message:data.msg,
              type:DialogType.exitoso,
              isVisible:true
          }
      });
      }else{
        dispatch({
          type:ActionTypes.setModalInfo,
          data:{
              title:"Error de activacion",
              message:data.msg,
              type:DialogType.peligro,
              isVisible:true
          }
      });

      }
     

    } ).catch(error=>{
      console.log({msg:error.message});
      dispatch({
        type:ActionTypes.setModalInfo,
        data:{
            title:"Error",
            message:"Error de comunicacion verifique su conexion a internet",
            type:DialogType.peligro,
            isVisible:true
        }
    });

    }).finally(()=>{
      dispatch({
        type:ActionTypes.setLoadingPage,
        data:false
      });
    });



   }

   
   const onSearchMunicipio = async (value_search) => {

    if (value_search) {
       try{

        const { data: { value } } = await AxiosInstance.post("maestros/get-municipio-filter", {
          search_query: value_search
        });
        setCiudades(value.map( item=>({label:item.name_raw,value:item.cod,barrios:item.barrios}) ));
        return value;
       }catch(e){
        return [];
       }

    }
 }


   const onSearchCliente = (event, newInputValue)=>{
        
    if ( newInputValue && newInputValue.length > 2){
        AxiosInstance.post(`maestros-marketplace/get-clientes-to-active`,{
          text_search:newInputValue,
          is_taking_pedido:true
        }).then(({data})=>{
          setClienteFiltro(data.value);
        }).catch(err=>{
         // setClienteFiltro([]);
        }).finally(()=>{

        });
    }

}
const defaultDataForm = {
        cliente:null,
          clasificacion_cliente:null,
          razon_social:'',
          nit:'',
          tipo_documento:null,
          usuarios_plataforma:[],
          direccion_entrega:"",
          email_notificaciones:"",
          celular_notificaciones:"",
          cod_sucursal_cliente:null,
          municipio:null,
          barrio:null
}

    const configClientActivacion =  {
        schemaValidator:validateDatosClientes,
        entityValues:defaultDataForm,
        typeAction:FormActions.AGREGAR,
        titleModal: "ACTIVACION CLIENTES",
        onSendForm:(type_action,payload,formConnect)=>{
          console.log({type_action,payload,formConnect});
       
          onSendFormClient(payload,formConnect);
        },
        buttomsAction:[
            /* {
              title:"Cancelar",
              buttomProps:{
                type:"button",
                onClick:()=>{
                    onCloseModal();
               
                 
                },
                color:"secondary"
            }
            }, */
            {
              title:"Guardar cambios",
              buttomProps:{
                type:"submit",
                size:"small"
              //  onClick:onSaveModData
              }
            }
        ],
        imputs:[
        {
                key:"cliente",
                keyValue:"cliente",
                label:"Cliente",
                responsiveSize:5,
                callFuncionOnChange:(value,{...props})=>{
                
                  if ( value ){
                    
                    props.setValue("usuarios_plataforma",value.usuarios_plataforma);
                    props.setValue("razon_social",value.razon_social);
                    props.setValue("nit",value.nit);
                    props.setValue("clasificacion_cliente",value.value_clasificacion);
                    props.setValue("tipo_documento",value.value_tipo_doc);
                    props.setValue("direccion_entrega",value.direccion_entrega);
                    props.setValue("cod_sucursal_cliente",value.cod_sucursal_cliente);
                    props.setValue("email_notificaciones",value.email_notificaciones);
                    props.setValue("celular_notificaciones",value.celular_notificaciones);
                    if ( value.municipio_cod && value.barrio_cod ){
                      props.setValue("municipio",{
                        label:value.municipio_nombre,
                        value:value.municipio_cod
                      });
                      props.setValue("barrio",{
                        label:value.barrio_nombre,
                        value:value.barrio_cod
                      });
                    }

                    
                
                  }

                },
                component: AutoCompleteInputWithLabel,
                    inputProps: {
                      size:"small",
                      typeInput:"autoComplete",
                      name:'cliente',
                      fullWidth: true,
                      isLoading: false,
                      //callFuncionOnChange:onSearchSucursalesClientes,
                      onInputChange: onSearchCliente,
                      options: clienteFiltro || [],
                      noOptionsText: "Lista vacia",
                      getOptionLabel: (option) => option.label,
                      isOptionEqualToValue: (option, value) => option.value === value.value,
                      filterOptions:(x) => x,
                    }
          },
          {
            key:"razon_social",
            keyValue:"razon_social",
            label: "Nombre o Razon social",
            component:InputWithLabel,
            responsiveSize:7,
            inputProps:{
              size:"small",
              type:"text",
             
            }
          },
          {
            key:"tipo_documento",
            keyValue:"tipo_documento",
            label: "Tipo de documento",
            component:SelectInputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
              items:maestrosCompartidos?.tipos_identificacion || [],
              disabled:true
             
            }
          },
          
          {
            key:"nit",
            keyValue:"nit",
            label: "Numero de documento",
            component:InputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
              disabled:true
            }
          },
          {
            key:"celular_notificaciones",
            keyValue:"celular_notificaciones",
            label: "Telefono",
            component:InputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
             
            }
          },
          {
            key:"email_notificaciones",
            keyValue:"email_notificaciones",
            label: "Correo (Opcional)",
            component:InputWithLabel,
            inputProps:{
              size:"small",
              type:"text",
             
            }
          },
               {
            key: "municipio",
            keyValue: "municipio",
            label: "Ciudad",
            component: AutoCompleteInputWithLabel,
           
            callFuncionOnChange:(value,formProps)=>{
              console.log({value});
              if ( value.barrios  ){
                setBarrios(value.barrios);
                return;
              }
              formProps.setValue("barrio",null);
            },
            inputProps: {
              size:"small",
              name: 'municipio',
              fullWidth: true,
              isLoading: false,
              multiple:false,
              autoComplete:"off",
              PopperComponent:(props)=><div hidden={!props.open} >
               
                 {props.children}
              </div>,
              onInputChange: (e,value)=>onSearchMunicipio(value),
              options: ciudades || [],
              noOptionsText: "Lista vacia",
              getOptionLabel: (option) => option.label,
              isOptionEqualToValue: (option, value) => option.value === value.value,
              filterOptions:(x) => x,
            }
          },
          {
            key: "barrio",
            keyValue: "barrio",
            label: "Barrio",
            component: AutoCompleteInputWithLabel,
         
            inputProps: {
              size:"small",
              name: 'barrio',
              PopperComponent:(props)=><div hidden={!props.open} >
               
                 {props.children}
              </div>,
             options: barrios || [],
              noOptionsText: "Lista vacia",
  
            }
          },
         {
            key:"direccion_entrega",
            keyValue:"direccion_entrega",
            label:"Direccion principal de entrega",
            component:InputWithLabel,
            inputProps:{
              type:"text",
              size:"small",
            }
          },
          {
            key:"clasificacion_cliente",
            keyValue:"clasificacion_cliente",
            label: "Tipo de cliente",
            component:SelectInputWithLabel,
            responsiveSize:12,
            inputProps:{
              size:"small",
              type:"text",
              items:maestrosCompartidos?.tipos_clientes 
             
            }
          },
         
         
         ],
        arrayInputs:[ 
          {
            label:"Usuarios asociados",
            key:"usuarios_plataforma",
            keyValue:"usuarios_plataforma",
            subSchema:usuariosAsociados,
            ItemRender:props=><UsuariosList {...props} maestros={maestrosCompartidos} />,
            inputs:[
              {
                key:"usuario",
                keyValue:"usuario",
                label: "Nombre completo",
                responsiveSize:12,
                component:InputWithLabel,
                inputProps:{
                  size:"small",
                  type:"text",
                
                }
              },
              {
                key:"celular",
                keyValue:"celular",
                label:"Telefono celular",
                component:InputWithLabel,
                inputProps:{
                  type:"number",
                  size:"small",
                //  customHelper:`SIN DIJITO DE VERIFICACION`,
                }
              },
              {
                key:"email",
                keyValue:"email",
                label:"Correo (Opcional)",
                component:InputWithLabel,
                inputProps:{
                  type:"text",
                  size:"small",
                }
              },
              {
                key:"cod_tipo_identificacion",
                keyValue:"cod_tipo_identificacion",
                label: "Tipo de documento",
                component:SelectInputWithLabel,
                inputProps:{
                  size:"small",
                  type:"text",
                  items:maestrosCompartidos?.tipos_identificacion || [],
                 
                }
              },
              {
                key:"nro_identificacion",
                keyValue:"nro_identificacion",
                label: "Numero de documento",
                component:InputWithLabel,
                inputProps:{
                  size:"small",
                  type:"text"
                }
              },
              
            ]
          },

        ],
       // FooterElement:()=><FooterElementModal config_client={configCliente}  />
      } ;

    return {
      configClientActivacion
    }
}